import React, { useState } from "react";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import Dashboard from "./Dashboard";
import Customers from "./Customers";
import Prospects from "./Prospects";
import Projects from "./Projects";
import ActivityLog from "./ActivityLog";

const SalesDashboard = () => {
  const [activeTab, setActiveTab] = useState("customers");

 const renderTabContent = () => {
  switch (activeTab) {
    // case "dashboard":
    //   return <Dashboard />; // Removed from UI but kept for reference
    case "customers":
      return <Customers />;
    case "prospects":
      return <Prospects />;
    case "projects":
      return <Projects />;
  }
};

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#eef2f6" }}>
      <Container className="p-4 w-100" style={{ maxWidth: "100%" }}>
        <Row className="mb-4">
          <Col>
            <h3 className="fw-bold">
              <i className="fas fa-chart-line text-primary me-2"></i>
              Sales Dashboard
            </h3>
          </Col>
        </Row>

        <Nav className="mb-2 pb-2">
          {[
            // { key: "dashboard", label: "Dashboard", icon: "fas fa-chart-bar" }, // Removed from UI but kept for reference
            { key: "customers", label: "Customers", icon: "fas fa-building" },
            { key: "prospects", label: "Prospects", icon: "fas fa-user" },
            {key: "projects",label: "Pipeline",icon: "fas fa-shopping-cart" },
          ].map(({ key, label, icon }) => (
            <NavItem key={key}>
              <NavLink
                onClick={() => setActiveTab(key)}
                className={`px-3 py-2 fw-semibold me-3 ${
                  activeTab === key
                    ? "text-primary border-bottom border-2 border-primary"
                    : "text-dark"
                }`}
                style={{
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <i className={`${icon} me-2`}></i>
                {label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {renderTabContent()}
      </Container>
    </div>
  );
};

export default SalesDashboard;
